module.exports = __webpack_public_path__ + "img/4.cb688011.jpg";